import React from "react";
import { Star } from "lucide-react";
import { useLang } from "@/context/Lang";
import { TESTIMONIALS } from "@/data";
import { Reveal, Overline } from "@/components/site/Reveal";

export default function Testimonials() {
  const { t, lang } = useLang();
  return (
    <section id="reviews" className="bg-[#F8F9FA] py-24 md:py-32" data-testid="reviews">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <Reveal className="max-w-3xl mb-14">
          <Overline>{t.reviews.overline}</Overline>
          <h2 className="mt-4 font-display font-extrabold text-navy text-4xl md:text-6xl leading-[0.95] tracking-tighter">
            {t.reviews.title}
          </h2>
        </Reveal>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
          {TESTIMONIALS.map((r, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08} className="break-inside-avoid bg-white border border-navy/10 p-6" >
              <div className="flex gap-0.5 mb-4" data-testid={`review-${i}`}>
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={16} className="fill-gold text-gold" />
                ))}
              </div>
              <p className="text-navy/80 leading-relaxed font-medium">"{r[lang]}"</p>
              <div className="mt-5 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-navy text-white flex items-center justify-center font-display font-bold">
                  {r.name.charAt(0)}
                </div>
                <div>
                  <div className="font-bold text-navy text-sm">{r.name}</div>
                  <div className="text-navy/45 text-xs">{r.city}</div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
